  <!-- Topbar-->
  <div class="topbar">
    <div class="topbar-column">
      <a class="hidden-md-down" href="mailto:info@andre-abt.com">
        <i class="icon-mail"></i>&nbsp; info@andre-abt.com</a>
      <a class="hidden-md-down" href="tel:+41792414544">
        <i class="icon-bell"></i>&nbsp; +41 79 241 45 44</a>
      <a class="social-button sb-facebook shape-none sb-dark" href="#" target="_blank">
        <i class="socicon-facebook"></i>
      </a>
      <a class="social-button sb-twitter shape-none sb-dark" href="#" target="_blank">
        <i class="socicon-twitter"></i>
      </a>
      <a class="social-button sb-instagram shape-none sb-dark" href="#" target="_blank">
        <i class="socicon-instagram"></i>
      </a>
      <a class="social-button sb-pinterest shape-none sb-dark" href="#" target="_blank">
        <i class="socicon-pinterest"></i>
      </a>
    </div>
  </div>
